import React, { useRef, useEffect } from 'react';
import { useMap } from '@vis.gl/react-google-maps';

import { GeoLocation, IItem } from './types';

interface MapFitBounderProps {
  geoLocations: GeoLocation;
  customMobileFitBound?: boolean;
  initBoundsItems?: IItem[];
  isResetRef?: React.MutableRefObject<boolean>;
}

const MOBILE_WIDTH = 768;
const AIRPORT_MOBILE_BOUNDS_LIMIT = 10;

const MapFitBounder: React.FC<MapFitBounderProps> = ({
  geoLocations,
  customMobileFitBound,
  initBoundsItems,
  isResetRef,
}) => {
  const map = useMap();
  const isInit = useRef(false);

  // 최초 지도 로딩 시, 지도의 bounds를 설정
  useEffect(() => {
    if (!isInit.current && !!geoLocations.features.length && map) {
      const bounds = new google.maps.LatLngBounds();

      const isMobile = window.innerWidth < MOBILE_WIDTH;

      if (customMobileFitBound && isMobile && initBoundsItems) {
        initBoundsItems.slice(0, AIRPORT_MOBILE_BOUNDS_LIMIT).forEach(item => {
          bounds.extend({
            lat: item.destination.location.latitude,
            lng: item.destination.location.longitude,
          });
        });
      } else {
        geoLocations.features.forEach(({ properties }) => {
          bounds.extend({
            lat: properties.destination.location.latitude,
            lng: properties.destination.location.longitude,
          });
        });
      }

      map?.fitBounds(bounds);
      isInit.current = true;
    }
  }, [map, geoLocations, customMobileFitBound, initBoundsItems]);

  // initBoundsItems는 filter값이 변경 시 동작, filter 변경 시에도 bounds를 재설정
  useEffect(() => {
    if (
      isInit.current &&
      map &&
      initBoundsItems?.length &&
      !isResetRef?.current
    ) {
      const bounds = new google.maps.LatLngBounds();

      const isMobile = window.innerWidth < MOBILE_WIDTH;

      const boundTargets =
        customMobileFitBound && isMobile
          ? initBoundsItems.slice(0, AIRPORT_MOBILE_BOUNDS_LIMIT)
          : initBoundsItems;

      boundTargets.forEach(item => {
        bounds.extend({
          lat: item.destination.location.latitude,
          lng: item.destination.location.longitude,
        });
      });

      map?.fitBounds(bounds);
    }
  }, [map, customMobileFitBound, initBoundsItems, isResetRef]);

  return null;
};

export default MapFitBounder;
